import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_MAIN_PAGE = "/dashboards/dba";
export const REDIRECT_TO_ENV_HOST = "/dashboards/host";
export const REDIRECT_TO_ENV_INSTANCE = "/dashboards/instance";

export const dashboardsPages = {
  id: "Dashboards",
  label: "Dashboards",
  icon: "dashboardApp",
  items: [
    {
      label: "DBA Dashboard",
      path: "/dashboards/dba",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Host_Dashboards,
        role: Roles.Read,
      },
    },
    {
      label: "Host Dashboard",
      path: "/dashboards/host",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Host_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/dashboards/host",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/dashboards/host_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Instance Dashboard",
      path: "/dashboards/instance",
      requireClientSelection: true,
      collectionNotRequired: true,
      permissions: {
        subject: Subjects.Instance_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/dashboards/instance",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/dashboards/instance_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Database Dashboard",
      path: "/dashboards/database",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Database_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/dashboards/database",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/dashboards/database_details",
          requireClientSelection: true,
        },
      ],
    },
  ],
};
